import React from "react";
import SentNotificationsTab from "../../../healthcare/patient/modalComponents/NotificationsTab";
import { Customer } from "../../../../types/inventory/CustomerTypes";
import {
	RELATED_ENTITY_TYPE_CUSTOMER,
	RELATED_ENTITY_TYPE_PATIENT,
} from "../../../../types/communications/NotificationRecipient";
import { isPatientDirectoryRow } from "../../../../types/inventory/customerRecord";

/**
 * CU-86d44j2ac — the shared recipient-generic notification component; a scheduled send is filed under
 * the entity type matching the row's CURRENT account type.
 */
const CustomerNotificationsTab: React.FC<{ customer: Customer }> = ({ customer }) => {
	const isPatient = isPatientDirectoryRow(customer);

	return (
		<SentNotificationsTab
			recipient={customer}
			relatedEntityType={isPatient ? RELATED_ENTITY_TYPE_PATIENT : RELATED_ENTITY_TYPE_CUSTOMER}
			recipientNoun={isPatient ? "patient" : "customer"}
		/>
	);
};

export default CustomerNotificationsTab;
